import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { from } from 'rxjs/internal/observable/from';
import * as contact from './my-contacts.actions';
import { HttpService } from '../../../global/http.service';
import { Manager } from '../../../global/interfaces';

@Injectable()
export class MyContactsEffects {
  public loadManagers$ = createEffect(() => this.actions$.pipe(
    ofType<contact.LoadManagersAction>(contact.ActionTypes.LOAD_MANAGERS),
    map(action => action.payload),
    switchMap((payload) =>
      this.loadManagers(payload).pipe(
        map(response => new contact.LoadManagersSuccessAction(response)
        ),
        catchError(error =>
        (from([
          new contact.LoadManagersFailedAction(error)
        ])
        ))
      )
    )
  ));

  public constructor(
    private readonly actions$: Actions,
    private readonly http: HttpService,
  ) {
  }

  private loadManagers(payload): Observable<any> {
    return this.http.get(`/clients/user-consultant?country=${payload.country}`);
  }
}
